// ========================================
// UTILITAIRE - Slugify
// Convertir un texte en slug URL-friendly
// ========================================

export const slugify = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
    .replace(/[^a-z0-9\s-]/g, '') // Supprimer les caractères spéciaux
    .trim()
    .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
    .replace(/-+/g, '-') // Supprimer les tirets multiples
    .replace(/^-+/, '') // Supprimer les tirets au début
    .replace(/-+$/, ''); // Supprimer les tirets à la fin
};

export default slugify;